const SHARED_ASSIGNMENTS = [
  { id: 1, name: "Midterm Essay" },
  { id: 2, name: "Final Exam Review" },
  { id: 3, name: 'Writing Prompt – "A World Without Technology"' },
  { id: 4, name: "Romeo and Juliet Analysis" },
  { id: 5, name: "Poetry Analysis" },
];

export const metricsClassesDemoPerformanceTrends = {
  1: {
    month: {
      labels: [
        "Sep '25",
        "Oct '25",
        "Nov '25",
        "Dec '25",
        "Jan '26",
        "Feb '26",
      ],
      datasets: [
        { label: "Need Support", data: [0, 0, 0, 0, 0, 0] },
        { label: "Growing", data: [2, 2, 1, 1, 1, 1] },
        { label: "Strong", data: [0, 0, 1, 1, 1, 1] },
      ],
    },
    week: {
      labels: [
        "Jan W1",
        "Jan W2",
        "Jan W3",
        "Jan W4",
        "Feb W1",
        "Feb W2",
        "Feb W3",
        "Feb W4",
      ],
      datasets: [
        { label: "Need Support", data: [0, 0, 0, 0, 0, 0, 0, 0] },
        { label: "Growing", data: [1, 2, 1, 1, 1, 1, 1, 1] },
        { label: "Strong", data: [1, 0, 1, 1, 1, 1, 1, 1] },
      ],
    },
    day: {
      labels: [
        "Feb 20",
        "Feb 21",
        "Feb 22",
        "Feb 23",
        "Feb 24",
        "Feb 25",
        "Feb 26",
        "Feb 27",
        "Feb 28",
      ],
      datasets: [
        { label: "Need Support", data: [0, 0, 0, 0, 0, 0, 0, 0, 0] },
        { label: "Growing", data: [1, 1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Strong", data: [1, 1, 1, 1, 1, 1, 1, 1, 1] },
      ],
    },
  },
  2: {
    month: {
      labels: [
        "Sep '25",
        "Oct '25",
        "Nov '25",
        "Dec '25",
        "Jan '26",
        "Feb '26",
      ],
      datasets: [
        { label: "Need Support", data: [0, 0, 1, 1, 1, 1] },
        { label: "Growing", data: [2, 2, 1, 1, 1, 1] },
        { label: "Strong", data: [0, 0, 0, 0, 0, 0] },
      ],
    },
    week: {
      labels: [
        "Jan W1",
        "Jan W2",
        "Jan W3",
        "Jan W4",
        "Feb W1",
        "Feb W2",
        "Feb W3",
        "Feb W4",
      ],
      datasets: [
        { label: "Need Support", data: [1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Growing", data: [1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Strong", data: [0, 0, 0, 0, 0, 0, 0, 0] },
      ],
    },
    day: {
      labels: [
        "Feb 20",
        "Feb 21",
        "Feb 22",
        "Feb 23",
        "Feb 24",
        "Feb 25",
        "Feb 26",
        "Feb 27",
        "Feb 28",
      ],
      datasets: [
        { label: "Need Support", data: [1, 1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Growing", data: [1, 1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Strong", data: [0, 0, 0, 0, 0, 0, 0, 0, 0] },
      ],
    },
  },
  3: {
    month: {
      labels: [
        "Sep '25",
        "Oct '25",
        "Nov '25",
        "Dec '25",
        "Jan '26",
        "Feb '26",
      ],
      datasets: [
        { label: "Need Support", data: [0, 0, 0, 1, 1, 1] },
        { label: "Growing", data: [2, 2, 2, 1, 1, 1] },
        { label: "Strong", data: [0, 0, 0, 0, 0, 0] },
      ],
    },
    week: {
      labels: [
        "Jan W1",
        "Jan W2",
        "Jan W3",
        "Jan W4",
        "Feb W1",
        "Feb W2",
        "Feb W3",
        "Feb W4",
      ],
      datasets: [
        { label: "Need Support", data: [1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Growing", data: [1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Strong", data: [0, 0, 0, 0, 0, 0, 0, 0] },
      ],
    },
    day: {
      labels: [
        "Feb 20",
        "Feb 21",
        "Feb 22",
        "Feb 23",
        "Feb 24",
        "Feb 25",
        "Feb 26",
        "Feb 27",
        "Feb 28",
      ],
      datasets: [
        { label: "Need Support", data: [1, 1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Growing", data: [1, 1, 1, 1, 1, 1, 1, 1, 1] },
        { label: "Strong", data: [0, 0, 0, 0, 0, 0, 0, 0, 0] },
      ],
    },
  },
};

export const metricsClassesDemoData = {
  1: {
    className: "9th Grade A",
    classInfo: { teacher: "John Doe" },
    counters: { students: 2, assignments: 5 },
    assignments: SHARED_ASSIGNMENTS,
    overallAvg: 80,
    studentGroups: { high: 1, medium: 1, low: 0 },
    classInsights: {
      summaryTrajectory: {
        overallSummary:
          "9th Grade A is performing above average overall. Alice continues to push toward the top of the class, while Brian maintains solid and consistent work. The primary shared challenge is counterargument integration — both students tend to present arguments one-sidedly without engaging opposing perspectives.",
        skillsTrajectory: [
          {
            status: "Declining",
            skillName: "Counterarguments",
            description:
              "Neither student is meaningfully engaging with opposing viewpoints in recent essays.",
          },
          {
            status: "Improving",
            skillName: "Thesis Development",
            description:
              "Both students have shown clearer, more arguable thesis statements over the last three assignments.",
          },
          {
            status: "Stable",
            skillName: "Academic Tone",
            description:
              "Tone is appropriate and consistent across all submissions.",
          },
          {
            status: "Improving",
            skillName: "Evidence Integration",
            description:
              "Evidence use has improved, with Alice leading the way in precision and sourcing.",
          },
          {
            status: "Stable",
            skillName: "Paragraph Transitions",
            description:
              "Transitions are functional for both students but could be more sophisticated.",
          },
        ],
      },
      growthProfiles: {
        growthProfilesSuggestions: {
          improving:
            "Sustain Alice's momentum by introducing more complex essay structures and encouraging engagement with secondary sources and counterarguments.",
          stable:
            "Brian is reliable and consistent — nudge him to take more analytical risks. Encourage bolder thesis claims and deeper evidence analysis.",
        },
      },
    },
    insightsLessonPlan: [
      {
        type: "persistent_issue",
        title: "Counterargument Practice",
        description:
          "Both students skip or oversimplify opposing views. Run a short in-class exercise where students must argue the opposite of their thesis for one paragraph before returning to their own argument.",
      },
      {
        type: "build_on",
        title: "Celebrate Alice's Progress",
        description:
          "Alice has improved consistently over 5 assignments — share an anonymized before/after excerpt to make her growth visible and encourage Brian to aim for the same trajectory.",
      },
      {
        type: "recurring_gap",
        title: "Conclusion Depth",
        description:
          "Both students tend to restate their thesis in the conclusion without synthesizing new insight. Introduce the 'so what?' prompt: what does this argument reveal about the text, the world, or the reader?",
      },
    ],
    studentTrajectories: {
      summary: {
        improving: { count: 1, percentage: 50 },
        stable: { count: 1, percentage: 50 },
      },
      data: [
        {
          id: 1,
          studentId: 1,
          firstName: "Alice",
          lastName: "Johnson",
          avgGrade: 87,
          scores: [78, 83, 88, 91, 93],
          growth: 15,
          trajectory: "improving",
        },
        {
          id: 2,
          studentId: 2,
          firstName: "Brian",
          lastName: "Kim",
          avgGrade: 72,
          scores: [71, 73, 70, 73, 72],
          growth: 1,
          trajectory: "stable",
        },
      ],
    },
    overallSummary:
      "9th Grade A is performing well above the class average. Alice is on a clear upward trajectory and Brian maintains consistent, reliable output. Counterargument integration is the main shared growth area for both students.",
    assignmentSummary: [
      { id: 1, name: "Midterm Essay", date: "2026-01-15", avgScore: 75 },
      { id: 2, name: "Final Exam Review", date: "2026-01-22", avgScore: 78 },
      {
        id: 3,
        name: 'Writing Prompt – "A World Without Technology"',
        date: "2026-01-29",
        avgScore: 79,
      },
      {
        id: 4,
        name: "Romeo and Juliet Analysis",
        date: "2026-02-05",
        avgScore: 82,
      },
      { id: 5, name: "Poetry Analysis", date: "2026-02-12", avgScore: 83 },
    ],
  },

  2: {
    className: "9th Grade B",
    classInfo: { teacher: "John Doe" },
    counters: { students: 2, assignments: 5 },
    assignments: SHARED_ASSIGNMENTS,
    overallAvg: 70,
    studentGroups: { high: 0, medium: 1, low: 1 },
    classInsights: {
      summaryTrajectory: {
        overallSummary:
          "9th Grade B presents a mixed picture. Diana is steadily improving and approaching the top tier, while Carlos shows a concerning decline that requires immediate intervention. The contrast between their trajectories underscores the need for differentiated support in this class.",
        skillsTrajectory: [
          {
            status: "Declining",
            skillName: "Counterarguments",
            description:
              "Carlos shows no engagement; Diana is improving but still inconsistent.",
          },
          {
            status: "Improving",
            skillName: "Evidence Integration",
            description:
              "Diana's evidence use has strengthened significantly over the last three assignments.",
          },
          {
            status: "Declining",
            skillName: "Thesis Development",
            description:
              "Carlos's thesis statements are becoming increasingly vague.",
          },
          {
            status: "Improving",
            skillName: "Academic Tone",
            description:
              "Diana maintains a strong academic register; Carlos's tone is inconsistent.",
          },
          {
            status: "Stable",
            skillName: "Paragraph Transitions",
            description:
              "Diana has functional transitions; Carlos struggles with coherence.",
          },
        ],
      },
      growthProfiles: {
        growthProfilesSuggestions: {
          improving:
            "Diana is on a strong trajectory — push her toward more sophisticated evidence use and introduce counterargument strategies to round out her essays.",
          declining:
            "Carlos needs urgent structural support. Focus on paragraph organization and basic thesis construction before addressing higher-order skills.",
        },
      },
    },
    insightsLessonPlan: [
      {
        type: "intervention",
        title: "Immediate Support for Carlos",
        description:
          "Carlos has declined on all 5 assignments. Schedule a one-on-one check-in to identify whether this is a motivation, comprehension, or foundational skills issue. A targeted scaffold on essay structure may help.",
      },
      {
        type: "build_on",
        title: "Leverage Diana's Growth",
        description:
          "Diana is showing consistent improvement — use her recent essays as anonymous exemplars to show the class what progress looks like in practice.",
      },
      {
        type: "recurring_gap",
        title: "Counterargument Integration for Both",
        description:
          "Neither student engages opposing views effectively. A short peer debate activity before the next writing assignment can build this habit experientially.",
      },
    ],
    studentTrajectories: {
      summary: {
        improving: { count: 1, percentage: 50 },
        declining: { count: 1, percentage: 50 },
      },
      data: [
        {
          id: 3,
          studentId: 3,
          firstName: "Carlos",
          lastName: "Rivera",
          avgGrade: 55,
          scores: [60, 57, 54, 52, 50],
          growth: -10,
          trajectory: "declining",
        },
        {
          id: 4,
          studentId: 4,
          firstName: "Diana",
          lastName: "Moore",
          avgGrade: 84,
          scores: [80, 82, 84, 86, 88],
          growth: 8,
          trajectory: "improving",
        },
      ],
    },
    overallSummary:
      "9th Grade B has a split performance: Diana is one of the strongest-improving students across all classes, while Carlos is showing a persistent and concerning decline. Targeted intervention for Carlos and sustained momentum for Diana are the immediate priorities.",
    assignmentSummary: [
      { id: 1, name: "Midterm Essay", date: "2026-01-15", avgScore: 70 },
      { id: 2, name: "Final Exam Review", date: "2026-01-22", avgScore: 70 },
      {
        id: 3,
        name: 'Writing Prompt – "A World Without Technology"',
        date: "2026-01-29",
        avgScore: 69,
      },
      {
        id: 4,
        name: "Romeo and Juliet Analysis",
        date: "2026-02-05",
        avgScore: 69,
      },
      { id: 5, name: "Poetry Analysis", date: "2026-02-12", avgScore: 69 },
    ],
  },

  3: {
    className: "9th Grade C",
    classInfo: { teacher: "John Doe" },
    counters: { students: 2, assignments: 5 },
    assignments: SHARED_ASSIGNMENTS,
    overallAvg: 67,
    studentGroups: { high: 0, medium: 1, low: 1 },
    classInsights: {
      summaryTrajectory: {
        overallSummary:
          "9th Grade C is slightly below the overall average and shows a gradual downward trend. Ethan is stable and consistent, but Fiona is showing a slow decline. Neither student is currently in the top tier, and both would benefit from more structured feedback on analytical depth.",
        skillsTrajectory: [
          {
            status: "Stable",
            skillName: "Thesis Development",
            description:
              "Both students produce functional thesis statements but lack specificity and ambition.",
          },
          {
            status: "Declining",
            skillName: "Evidence Integration",
            description:
              "Fiona's evidence use has weakened; Ethan's is stable but surface-level.",
          },
          {
            status: "Stable",
            skillName: "Academic Tone",
            description:
              "Both students maintain appropriate tone throughout submissions.",
          },
          {
            status: "Declining",
            skillName: "Counterarguments",
            description:
              "Neither student engages opposing views; Fiona's attempts have become less frequent.",
          },
          {
            status: "Stable",
            skillName: "Paragraph Transitions",
            description:
              "Transitions are present but mechanical for both students.",
          },
        ],
      },
      growthProfiles: {
        growthProfilesSuggestions: {
          stable:
            "Ethan is reliable but needs a push — encourage more assertive analytical claims and deeper interpretation rather than just comprehension-level responses.",
          declining:
            "Fiona needs early intervention. Focus on maintaining what she does well (tone, structure) while rebuilding her evidence integration and engagement habits.",
        },
      },
    },
    insightsLessonPlan: [
      {
        type: "intervention",
        title: "Early Support for Fiona",
        description:
          "Fiona's gradual decline suggests growing disengagement or difficulty. A brief one-on-one conversation and a clear writing scaffold for the next assignment could help reverse this trend before it deepens.",
      },
      {
        type: "persistent_issue",
        title: "Push Beyond Comprehension",
        description:
          "Both students demonstrate they understand the texts, but their essays stay at the summary level. Introduce a 'claim → evidence → so what?' paragraph template to anchor deeper analysis.",
      },
      {
        type: "recurring_gap",
        title: "Counterargument Habit",
        description:
          "Neither student has developed a consistent counterargument practice. Dedicate 10 minutes of the next class to modeling how to acknowledge and refute an opposing view using the current reading.",
      },
    ],
    studentTrajectories: {
      summary: {
        stable: { count: 1, percentage: 50 },
        declining: { count: 1, percentage: 50 },
      },
      data: [
        {
          id: 5,
          studentId: 5,
          firstName: "Ethan",
          lastName: "Davis",
          avgGrade: 71,
          scores: [70, 71, 70, 72, 71],
          growth: 1,
          trajectory: "stable",
        },
        {
          id: 6,
          studentId: 6,
          firstName: "Fiona",
          lastName: "Zhang",
          avgGrade: 63,
          scores: [68, 66, 64, 62, 60],
          growth: -8,
          trajectory: "declining",
        },
      ],
    },
    overallSummary:
      "9th Grade C is performing slightly below the overall average with a gradual downward trend. Ethan's stability and Fiona's decline need to be addressed with differentiated strategies to prevent further regression.",
    assignmentSummary: [
      { id: 1, name: "Midterm Essay", date: "2026-01-15", avgScore: 69 },
      { id: 2, name: "Final Exam Review", date: "2026-01-22", avgScore: 69 },
      {
        id: 3,
        name: 'Writing Prompt – "A World Without Technology"',
        date: "2026-01-29",
        avgScore: 67,
      },
      {
        id: 4,
        name: "Romeo and Juliet Analysis",
        date: "2026-02-05",
        avgScore: 67,
      },
      { id: 5, name: "Poetry Analysis", date: "2026-02-12", avgScore: 66 },
    ],
  },
};

export const metricsClassDemoData = metricsClassesDemoData[1];
export const metricsClassDemoPerformanceTrends =
  metricsClassesDemoPerformanceTrends[1];

export const metricsClassEmptyData = {
  className: null,
  classInfo: { teacher: null },
  counters: { students: null, assignments: null },
  assignments: [],
  overallAvg: 0,
  studentGroups: { high: 0, medium: 0, low: 0 },
  overallSummary: null,
  assignmentSummary: [],
  classInsights: null,
  insightsLessonPlan: [],
  studentTrajectories: { summary: {}, data: [] },
};
